import type { Tokens } from '@zeus/themes';

export function createUi(tokens: Tokens) {
  return tokens.ui;
}
